import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateQuotationSchema } from "@/v2/schema/quotation";
import { Quotation } from "@/v2/types";

export default async function UpdateQuotation({
    id,
    data,
}: {
    id: string;
    data: CreateQuotationSchema;
}): Promise<Quotation> {
    const res = await apiClientWithRefreshToken({
        url: `/quotations/${id}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
